import React from "react";
import { TextField } from "@mui/material";
import { panelFieldColorLockSx, panelFormFieldSx } from "../../design-system/panel/panelFormSx";
import { toSxArray } from "./mergePanelSx";

/**
 * Light panel TextField.
 * Safari / macOS Kişiler (Contacts) ve tarayıcı otomatik tamamlama
 * önerilerini engellemek için güvenli varsayılan inputProps içerir.
 */
export default function PanelTextField({
  sx,
  variant = "outlined",
  fullWidth = true,
  autoComplete = "one-time-code",
  size = "small",
  inputProps,
  ...rest
}) {
  const mergedInputProps = {
    autoComplete: "one-time-code",
    autoCorrect: "off",
    autoCapitalize: "none",
    spellCheck: "false",
    "data-form-type": "other",
    "data-lpignore": "true",
    "data-1p-ignore": "true",
    ...inputProps,
  };

  return (
    <TextField
      variant={variant}
      fullWidth={fullWidth}
      autoComplete={autoComplete}
      inputProps={mergedInputProps}
      {...rest}
      sx={toSxArray(panelFormFieldSx, sx, panelFieldColorLockSx)}
    />
  );
}
